/***
 * 姓名 :D
 * 创建时间:2019-3-8
 * 描述：用于路由模块初始化地址
 * 更新记录：
 */
import { Observable, of } from 'rxjs';
import { PreloadingStrategy, Route } from '@angular/router';
import { Injectable, NgZone } from '@angular/core';
export function requestIdle(zone: NgZone) {
    const win: any = window;
    if (win.requestIdleCallback) {
      return (fn) => win.requestIdleCallback(fn);
    }
    return (fn) => zone.runOutsideAngular(() => win.setTimeout(fn, 10000));
  }

@Injectable()
export class SwSelectivePreloadingStrategy implements PreloadingStrategy {

    // 在 主模块地址加上 data :{preload :true}
    constructor() { }
    preloadeModules: string[] = []
    preload(router: Route, load: () => Observable<any>): Observable<any> {
        if (router.data && router.data["preload"]) {
            this.preloadeModules.push(router.path);
            return load();
        } else {
            return of(null)
        }
    }
}